import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getBusinessGroupsubscriptionDatatable,
  createNewBusinessGroupsubscription,
  expireBusinessGroupsubscription,
} from './thunks';
import { businessGroupsubscriptionState } from './types';

export const name = 'BusinessGroupsubscription';

const initialState: businessGroupsubscriptionState = {
  data: null,
  status: 'idle',
};
export const getBusinessGroupsubscriptionDatatableAsync = createAsyncThunk(
  name + '/datatable',
  getBusinessGroupsubscriptionDatatable
);
export const createNewBusinessGroupsubscriptionAsync = createAsyncThunk(
  name + '/create',
  createNewBusinessGroupsubscription
);

export const expireBusinessGroupsubscriptionAsync = createAsyncThunk(
  name + '/expire',
  expireBusinessGroupsubscription
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: (_) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBusinessGroupsubscriptionDatatableAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(
        getBusinessGroupsubscriptionDatatableAsync.fulfilled,
        (state, action) => {
          state.status = 'idle';
          state.data = action.payload;
        }
      )
      .addCase(
        getBusinessGroupsubscriptionDatatableAsync.rejected,
        (state, action) => {
          state.status = 'failed';
        }
      );
  },
});

export const actions = slice.actions;

export default slice.reducer;
